import * as yup from 'yup';
import { PASSWORD_MIN_ERROR, PASSWORD_REQUIRED_ERROR, PASSWORD_RULES_ERROR } from '../SignUp';
import { YEmailValidate } from '../yupValidators';
import YupPassword from 'yup-password';
YupPassword(yup);
export const resetPasswordInitialValues = {
  email: ''
};
export const resetPasswordSetInitialValues = {
  password: '',
  repPassword: '',
  termsAndConditions: false,
  privacyPolicy: false,
  userAcknowledgment: false
};
export const resetPasswordSchema = yup.object({
  email: YEmailValidate
});
export const resetPasswordSetSchema = yup.object({
  password: yup.string().trim().minUppercase(1, PASSWORD_RULES_ERROR).minLowercase(1, PASSWORD_RULES_ERROR).minNumbers(1, PASSWORD_RULES_ERROR).minSymbols(1, PASSWORD_RULES_ERROR).min(8, PASSWORD_MIN_ERROR).required(PASSWORD_REQUIRED_ERROR),
  repPassword: yup.string().trim().oneOf([yup.ref('password'), null]).required(),
  termsAndConditions: yup.boolean().oneOf([true], '').required(),
  privacyPolicy: yup.boolean().oneOf([true], '').required(),
  userAcknowledgment: yup.boolean().oneOf([true], '').required()
});